import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

const diffInDays = (fromMs, toMs) => {
  const diffMs = toMs - fromMs;
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
};

const diffInMonthsApprox = (fromMs, toMs) => {
  const diffMs = toMs - fromMs;
  return Math.floor(diffMs / (1000 * 60 * 60 * 24 * 30.44));
};

const getTypoStatusText = ({ isAvailable, expiresAt }) => {
  // For typos, API often only returns isAvailable; keep same rule set.
  if (isAvailable === true) return 'Available';

  const exp = Number(expiresAt || 0);
  if (!exp) return 'Unavailable';

  const now = Date.now();
  const days = diffInDays(now, exp);
  const months = diffInMonthsApprox(now, exp);

  if (days < 0) return 'Expired';
  if (months >= 1) return `Expires in ${plural(months, 'month')}`;
  return `Expires in ${plural(Math.max(0, days), 'day')}`;
};

/**
 * Transforms the typo_cybersquating_prevention criteria from WooRank API response.
 * @param {Object} typoCriteria - criteria.typo_cybersquating_prevention
 * @returns {Object} transformed criteria
 */
export const transformTypoAvailability = (typoCriteria) => {
  if (!typoCriteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No domains were found.',
      data: null,
    };
  }

  const wooRankStatus = typoCriteria?.status || 'neutral';
  const importance = typoCriteria?.importance || 0;
  const solvability = typoCriteria?.solvability || 0;

  const domains = Array.isArray(typoCriteria?.data) ? typoCriteria.data : [];
  const rows = domains
    .map((d) => {
      const domain = d?.domain || '';
      if (!domain) return null;
      return {
        domain,
        statusText: getTypoStatusText({ isAvailable: d?.isAvailable, expiresAt: d?.expiresAt }),
      };
    })
    .filter(Boolean);

  const isEmpty = rows.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'No domains were found.' : null,
    data: isEmpty ? null : { rows },
  };
};

export default transformTypoAvailability;


